import { OnInit, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-desglose-confeccion-reetiquetado',
    templateUrl: './desglose-confeccion.component.html'
})
export class DesgloseConfeccionReetiquetadoComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 5;
    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 1;
    public firstItemList = 0;
    public lastItemList = this.itemsPerPage;
    public totalItems: this;
    public readonly visiblePages = 3;

    @Input() confecciones;

    constructor(
        private readonly _translate: TranslateService,
    ) {}

    ngOnInit() {
        this.totalItems = this.confecciones.length;
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public pageChange(page) {
        this.currentPage = page;
        this.firstItemList = this.itemsPerPage * (page - 1);
        this.lastItemList = this.itemsPerPage * page;
    }
}
